export const DetailPanelStyle = {
  baseStyle: {
    flexDirection: 'column',
    flex: '1 0 0',
    backgroundColor: 'bg.subtle',
    color: 'fg.muted',
    isolation: 'isolate',
  },
}

export const useDetailPanelStyle = () => {
  return DetailPanelStyle.baseStyle
}
